import { render, staticRenderFns } from "./communityManagementsList.vue?vue&type=template&id=6522cc7b&scoped=true&"
import script from "./communityManagementsList.vue?vue&type=script&lang=js&"
export * from "./communityManagementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6522cc7b",
  null
  
)

export default component.exports